<!--
  Componente raiz da aplicação aquare!a.
  Responsável por renderizar a Navbar, o conteúdo da rota atual (router-view),
  o chat (quando logado) e o modal global de mensagens.
-->

<template>
  <main>
    <Navbar />
    <!-- <router-view :key="$route.meta.forceRefreshKey || $route.fullPath" /> -->
    <!-- <router-view :key="$route.meta.forceRefreshKey || $route.matched[0]?.path" /> -->
    <KeepAlive include="ProfileView">
      <router-view :key="routeKey" />
    </KeepAlive>
    <ChatApp v-if="isLogged" />
    <ModalMessage 
      ref="globalModal" 
      :title="modalData.title" 
      :message="modalData.message" 
      :redirectTo="modalData.redirectTo"
    />
  </main>
</template>

<script>
import { computed, watch, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useUserStore } from '@/utils/stores/userStore'
import { modalEvent } from '@/utils/eventBus'

import Navbar from '@/components/Navbar.vue'
import ChatApp from '@/components/Chat/ChatApp.vue'
import ModalMessage from '@/components/Modal/ModalMessage.vue'

export default {
  name: 'App',

  components: {
    Navbar,
    ChatApp,
    ModalMessage
  },
  
  setup() {
    const route = useRoute()
    const userStore = useUserStore()
    const globalModal = ref(null)
    const modalData = ref({
      title: '',
      message: '',
      redirectTo: null
    })

    const isLogged = computed(() => !!userStore.id)

    // chave híbrida: usa forceRefreshKey quando existir, senão matched[0]?.path
    const routeKey = computed(() => {
      // Se for página de perfil → força recriação quando mudar de usuário
      if (route.name === 'colaborador') {
        return route.params.id
      }
      // Se a rota for REA → usa fullPath (mantém navegação em trilhas)
      if (route.name === 'rea') {
        return route.fullPath
      }
      // Se tiver forceRefreshKey → usa ele
      if (route.meta.forceRefreshKey) {
        return route.meta.forceRefreshKey
      }
      // Senão, padrão: matched[0]?.path (evita recargas desnecessárias)
      return route.matched[0]?.path
    })
  
    watch(modalEvent, (newValue) => {
      if (newValue.show) {
        modalData.value = {
          title: newValue.title,
          message: newValue.message,
          redirectTo: newValue.redirectTo
        }
        globalModal.value?.openModal()
      }
    }, { deep: true })

    return { isLogged, modalData, globalModal, routeKey }
  }
  
}
</script>